require("source-map-support").install(), function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Drawer", [], t) : "object" == typeof exports ? exports.Drawer = t() : e.Drawer = t();
}(this, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/", n(n.s = 342);
  }({
    0: function _(e, t) {
      e.exports = require("react");
    },
    1: function _(e, t) {
      e.exports = require("prop-types");
    },
    10: function _(e, t, n) {
      "use strict";

      var r = n(3),
          o = n.n(r),
          i = n(1),
          a = n.n(i),
          c = n(2);

      function u() {
        var e = o()(["\n  align-content: ", ";\n  align-items: ", ";\n  align-self: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  order: ", ";\n  overflow: ", ";\n"]);
        return u = function u() {
          return e;
        }, e;
      }

      var s = n.n(c).a.div(u(), function (e) {
        return e.alignContent;
      }, function (e) {
        return e.alignItems;
      }, function (e) {
        return e.alignSelf;
      }, function (e) {
        return e.inline ? "inline-flex" : "flex";
      }, function (e) {
        return e.flexBasis;
      }, function (e) {
        return e.flexDirection;
      }, function (e) {
        return e.flexGrow;
      }, function (e) {
        return e.flexShrink;
      }, function (e) {
        return e.flexWrap ? "wrap" : "nowrap";
      }, function (e) {
        return e.justifyContent;
      }, function (e) {
        return e.order;
      }, function (e) {
        return e.overflow;
      });
      s.propTypes = {
        alignContent: a.a.string,
        alignItems: a.a.string,
        alignSelf: a.a.string,
        flexBasis: a.a.oneOfType([a.a.number, a.a.string]),
        flexDirection: a.a.string,
        flexGrow: a.a.number,
        flexShrink: a.a.number,
        flexWrap: a.a.bool,
        inline: a.a.bool,
        justifyContent: a.a.string,
        overflow: a.a.string,
        order: a.a.number
      }, s.defaultProps = {
        alignContent: "stretch",
        alignItems: "stretch",
        alignSelf: "auto",
        flexBasis: "auto",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
        flexWrap: !1,
        inline: !1,
        justifyContent: "flex-start",
        order: 0,
        overflow: "hidden"
      }, s.displayName = "FlexContainer", t.a = s;
    },
    11: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
    },
    12: function _(e, t) {
      e.exports = require("@fortawesome/react-fontawesome");
    },
    124: function _(e, t, n) {
      "use strict";

      var r = n(0);

      t.a = function () {
        var e, t;
        return Object(r.useEffect)(function () {
          return e = document.body.scrollTop, t = document.documentElement.scrollTop, function () {
            e ? document.body.scrollTop = e : t && (document.documentElement.scrollTop = t);
          };
        }, []), null;
      };
    },
    15: function _(e, t, n) {
      "use strict";

      n.d(t, "g", function () {
        return r;
      }), n.d(t, "c", function () {
        return o;
      }), n.d(t, "b", function () {
        return a;
      }), n.d(t, "d", function () {
        return c;
      }), n.d(t, "a", function () {
        return i;
      }), n.d(t, "e", function () {
        return u;
      }), n.d(t, "f", function () {
        return s;
      });
      var r = 150,
          o = 250,
          i = 500,
          a = 40,
          c = "cubic-bezier(0.25, 0.01, 0.25, 1)",
          u = [.25, .01, .25, 1],
          s = 150;
    },
    16: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/getPrototypeOf");
    },
    18: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/assertThisInitialized");
    },
    2: function _(e, t) {
      e.exports = require("styled-components");
    },
    21: function _(e, t, n) {
      "use strict";

      var r = n(3),
          o = n.n(r),
          i = n(6),
          a = n.n(i),
          c = n(11),
          u = n.n(c),
          s = n(0),
          l = n.n(s),
          f = n(2),
          p = n.n(f),
          d = n(7);

      function m() {
        var e = o()(["\n  display: flex;\n  position: relative;\n  max-width: ", ";\n\n  flex: ", ";\n  flex-wrap: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n\n  ", "\n  ", "\n"]);
        return m = function m() {
          return e;
        }, e;
      }

      function b(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      var y = function y(e) {
        var t = e.children,
            n = e.gutter,
            r = u()(e, ["children", "gutter"]);
        return l.a.createElement(g, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? b(Object(n), !0).forEach(function (t) {
              a()(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({
          gutter: n
        }, r), l.a.Children.map(t, function (e) {
          return e && l.a.cloneElement(e, {
            gutter: n
          });
        }));
      },
          g = p.a.div(m(), function (e) {
        return e.width || "none";
      }, function (e) {
        return e.flex;
      }, function (e) {
        return e.flexWrap ? "wrap" : "nowrap";
      }, function (e) {
        return e.reverse ? "row-reverse" : "row";
      }, function (e) {
        return e.alignItems;
      }, function (e) {
        return e.justifyContent;
      }, function (e) {
        var t = e.gutter;
        return Object(d.a)({
          attribute: "margin-left",
          value: t ? -t / 2 : 0
        });
      }, function (e) {
        var t = e.gutter;
        return Object(d.a)({
          attribute: "margin-right",
          value: t ? -t / 2 : 0
        });
      });

      g.displayName = "RowV2", y.defaultProps = {
        flex: "1 1 auto",
        gutter: 0,
        reverse: !1,
        flexWrap: !1,
        alignItems: void 0,
        justifyContent: void 0
      }, t.a = y;
    },
    22: function _(e, t) {
      e.exports = require("@fortawesome/fontawesome-svg-core");
    },
    23: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/classCallCheck");
    },
    24: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/createClass");
    },
    25: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/inherits");
    },
    26: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/possibleConstructorReturn");
    },
    262: function _(e, t, n) {
      "use strict";

      n.r(t);
      var r = n(6),
          o = n.n(r),
          i = n(3),
          a = n.n(i),
          c = n(0),
          u = n.n(c),
          s = n(77),
          l = n(2),
          f = n.n(l),
          p = n(29),
          d = n.n(p),
          m = n(22),
          b = n(12),
          y = n(35),
          g = n(98),
          h = n(10),
          v = n(21),
          O = n(36),
          x = n(124);

      function w(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function j(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? w(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }

      function P() {
        var e = a()(["\n  background-color: ", ";\n\n  ", ";\n"]);
        return P = function P() {
          return e;
        }, e;
      }

      function E() {
        var e = a()(["\n    height: 100%;\n    box-shadow: 0 0 4px 1px ", ";\n    border: solid 1px ", ";\n    padding: 20px;\n    box-sizing: border-box;\n    width: ", "px;\n  "]);
        return E = function E() {
          return e;
        }, e;
      }

      function S() {
        var e = a()(["\n      width: 100vw;\n      height: 100vh;\n    "]);
        return S = function S() {
          return e;
        }, e;
      }

      m.library.add(y.faTimes);

      var D = f()(h.a).attrs({
        flexDirection: "column"
      })(P(), function (e) {
        return e.theme.colors.white;
      }, function (e) {
        var t = e.theme.colors,
            n = e.fullScreen,
            r = e.width;
        return n ? Object(l.css)(S()) : Object(l.css)(E(), t.boxshadowmedium, t.grey20, r);
      }),
          T = {
        position: "fixed",
        top: "0px",
        right: "0px",
        opacity: 0,
        transition: "all ".concat(O.b, "ms ").concat(O.c),
        willChange: "transform, opacity",
        transform: "translate(100%, 0px)",
        zIndex: 999
      },
          C = {
        entered: {
          transform: "translate(0%, 0px)",
          opacity: 1
        },
        exiting: {
          transform: "translate(100%, 0px)",
          opacity: 0
        }
      },
          k = function k(e) {
        var t = e.isShown,
            n = e.children,
            r = e.onCloseButtonClick,
            o = e.fullScreen,
            i = e.header,
            a = e.width;
        return Object(s.createPortal)(u.a.createElement(d.a, {
          in: t,
          timeout: {
            enter: 0,
            exit: O.b
          },
          unmountOnExit: !0,
          mountOnEnter: !0
        }, function (e) {
          return u.a.createElement(D, {
            fullScreen: o,
            width: a,
            style: j({}, T, {}, C[e])
          }, u.a.createElement(x.a, null), u.a.createElement(g.RemoveScroll, null, i || u.a.createElement(v.a, {
            justifyContent: "flex-end",
            flex: "0 0 0px"
          }, u.a.createElement(b.FontAwesomeIcon, {
            icon: ["far", "times"],
            onClick: r,
            style: {
              cursor: "pointer"
            }
          })), u.a.createElement(v.a, null, n)));
        }), document.body);
      };

      k.defaultProps = {
        isShown: !1,
        fullScreen: !1,
        header: null,
        width: 300
      };
      var q = k;
      t.default = q;
    },
    29: function _(e, t) {
      e.exports = require("react-transition-group/Transition");
    },
    3: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    342: function _(e, t, n) {
      e.exports = n(262);
    },
    35: function _(e, t) {
      e.exports = require("@fortawesome/pro-regular-svg-icons/faTimes");
    },
    36: function _(e, t, n) {
      "use strict";

      n.d(t, "a", function () {
        return r.a;
      }), n.d(t, "e", function () {
        return v;
      }), n.d(t, "b", function () {
        return p.c;
      }), n.d(t, "d", function () {
        return p.e;
      }), n.d(t, "c", function () {
        return p.d;
      });
      var r = n(44),
          o = (n(64), n(3)),
          i = n.n(o),
          a = n(0),
          c = n.n(a),
          u = n(2),
          s = n.n(u),
          l = n(29),
          f = n.n(l),
          p = n(15);

      function d() {
        var e = i()(["\n  ", "\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      function m() {
        var e = i()(["\n  ", "\n  transition: transform ", "ms;\n  transform-origin: center center;\n"]);
        return m = function m() {
          return e;
        }, e;
      }

      var b = function b(e) {
        var t = e.state,
            n = e.rotation;
        return {
          transform: "rotate(".concat("entered" === t ? n : 0, "deg)")
        };
      },
          y = s.a.div(m(), b, p.c),
          g = s.a.div(d(), b),
          h = function h(e) {
        var t = e.rotate,
            n = e.degrees,
            r = e.disableAnimation,
            o = e.children;
        return c.a.createElement(f.a, {
          in: t,
          timeout: {
            enter: 0,
            exit: p.c
          },
          enter: !1,
          exit: !1
        }, function (e) {
          return r ? c.a.createElement(g, {
            rotation: n,
            state: e
          }, o) : c.a.createElement(y, {
            rotation: n,
            state: e
          }, o);
        });
      };

      h.displayName = "RotateTransition", h.defaultProps = {
        rotate: !1,
        degrees: 0,
        disableAnimation: !1
      };
      var v = h;
      n(56), n(78), n(79);
    },
    42: function _(e, t, n) {
      "use strict";

      var r = n(6),
          o = n.n(r),
          i = n(11),
          a = n.n(i),
          c = n(3),
          u = n.n(c),
          s = n(0),
          l = n.n(s),
          f = n(2);

      function p(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function d() {
        var e = u()(["\n  display: block;\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      var m = n.n(f).a.div(d()),
          b = function b(e) {
        var t = e.children,
            n = e.className,
            r = a()(e, ["children", "className"]);
        return l.a.createElement(m, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(n), !0).forEach(function (t) {
              o()(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }({
          className: n
        }, r), t);
      };

      b.displayName = "FluidContainer", b.defaultProps = {
        className: void 0
      }, t.a = b;
    },
    44: function _(e, t, n) {
      "use strict";

      var r = n(6),
          o = n.n(r),
          i = n(0),
          a = n.n(i),
          c = n(29),
          u = n.n(c),
          s = n(15);

      function l(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function f(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? l(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }

      var p = {
        transition: "opacity ".concat(s.g, "ms ease-in-out"),
        opacity: 0,
        willChange: "opacity",
        width: "inherit"
      },
          d = {
        entered: {
          opacity: 1
        },
        exiting: {
          opacity: 0
        }
      },
          m = function m(e) {
        var t = e.show,
            n = e.children;
        return a.a.createElement(u.a, {
          in: t,
          timeout: {
            enter: 0,
            exit: s.g
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (e) {
          return a.a.createElement("div", {
            style: f({}, p, {}, d[e])
          }, n);
        });
      };

      m.displayName = "FadeTransition", t.a = m;
    },
    56: function _(e, t, n) {
      "use strict";

      var r = n(6),
          o = n.n(r),
          i = n(0),
          a = n.n(i),
          c = n(29),
          u = n.n(c),
          s = n(15),
          l = n(42);

      function f(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function p(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? f(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }

      var d = {
        transition: "opacity ".concat(s.g, "ms ease-in-out"),
        opacity: 0
      },
          m = {
        entering: {
          opacity: 0,
          position: "absolute"
        },
        entered: {
          opacity: 1,
          position: "relative"
        },
        exited: {
          opacity: 0,
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        }
      },
          b = function b(e) {
        var t = e.children,
            n = e.activeIndex;
        return a.a.createElement(a.a.Fragment, null, t.map(function (e, t) {
          return a.a.createElement(u.a, {
            key: "".concat(t),
            in: t === n,
            timeout: s.g,
            appear: !0
          }, function (t) {
            return a.a.createElement(l.a, {
              style: p({}, d, {}, m[t])
            }, e);
          });
        }));
      };

      b.displayName = "SelectionFadeTransition", t.a = b;
    },
    6: function _(e, t) {
      e.exports = require("@babel/runtime/helpers/defineProperty");
    },
    64: function _(e, t, n) {
      "use strict";

      var r = n(6),
          o = n.n(r),
          i = n(0),
          a = n.n(i),
          c = n(29),
          u = n.n(c),
          s = n(15);

      function l(e, t) {
        var n = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function f(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? l(Object(n), !0).forEach(function (t) {
            o()(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }

      var p = {
        position: "absolute",
        top: "".concat(s.b, "px"),
        transition: "all ".concat(s.c, "ms cubic-bezier(0.25, 0.01, 0.25, 1)"),
        transform: "translate(0px, 0px)",
        opacity: 0,
        willChange: "transform, opacity"
      },
          d = {
        entered: {
          transform: "translate(0px, -".concat(s.b, "px)"),
          opacity: 1
        },
        exiting: {
          transform: "translate(0px, -".concat(2 * s.b, "px)"),
          opacity: 0
        }
      },
          m = function m(e) {
        var t = e.show,
            n = e.children;
        return a.a.createElement(u.a, {
          in: t,
          timeout: {
            enter: 0,
            exit: s.c
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (e) {
          return a.a.createElement("div", {
            style: f({}, p, {}, d[e])
          }, n);
        });
      };

      m.displayName = "MoveTransition", t.a = m;
    },
    7: function _(e, t, n) {
      "use strict";

      var r = n(3),
          o = n.n(r),
          i = n(2);

      function a() {
        var e = o()(["", ": ", ""]);
        return a = function a() {
          return e;
        }, e;
      }

      function c() {
        var e = o()(["", ": ", "px"]);
        return c = function c() {
          return e;
        }, e;
      }

      t.a = function (e) {
        var t = e.attribute,
            n = e.value;

        if (void 0 !== n) {
          if ("number" == typeof n) return Object(i.css)(c(), t, n);
          if ("string" == typeof n) return Object(i.css)(a(), t, n);
          throw new Error("".concat(n, " is not of valid type for ").concat(t, ".\n      prop can either number or string"));
        }
      };
    },
    77: function _(e, t) {
      e.exports = require("react-dom");
    },
    78: function _(e, t, n) {
      "use strict";

      var r = n(3),
          o = n.n(r),
          i = n(0),
          a = n.n(i),
          c = n(2),
          u = n.n(c),
          s = n(29),
          l = n.n(s),
          f = n(15);

      function p() {
        var e = o()(["\n  transition: transform ", "ms ease-in-out;\n  transform-origin: ", ";\n  transform: ", ";\n  height: calc(100% + 8px);\n  width: calc(100% + 8px);\n  position: absolute;\n  top: -4px;\n  left: -4px;\n"]);
        return p = function p() {
          return e;
        }, e;
      }

      function d() {
        var e = o()(["\n  position: relative;\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      var m = {
        TOP: "top",
        BOTTOM: "bottom",
        LEFT: "left",
        RIGHT: "right"
      },
          b = u.a.div(d()),
          y = u.a.div(p(), f.c, function (e) {
        return e.directionToOpen;
      }, function (e) {
        var t = e.isLeftRight,
            n = e.scaleSize;
        return t ? "scaleX(".concat(n, ")") : "scaleY(".concat(n, ")");
      }),
          g = function g(e) {
        var t = e.show,
            n = e.children,
            r = e.directionToOpen,
            o = [m.LEFT, m.RIGHT].includes(r);
        return a.a.createElement(b, null, a.a.createElement(l.a, {
          in: t,
          timeout: {
            enter: 0,
            exit: f.c
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (e) {
          return a.a.createElement(y, {
            isLeftRight: o,
            scaleSize: "entered" === e ? 1 : 0,
            directionToOpen: r
          }, n);
        }));
      };

      g.displayName = "SlideTransition", g.defaultProps = {
        directionToOpen: "bottom"
      }, t.a = g;
    },
    79: function _(e, t, n) {
      "use strict";

      var r = n(23),
          o = n.n(r),
          i = n(24),
          a = n.n(i),
          c = n(18),
          u = n.n(c),
          s = n(25),
          l = n.n(s),
          f = n(26),
          p = n.n(f),
          d = n(16),
          m = n.n(d),
          b = n(6),
          y = n.n(b),
          g = n(3),
          h = n.n(g),
          v = n(0),
          O = n.n(v),
          x = n(2),
          w = n.n(x),
          j = n(15);

      function P() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }

      function E() {
        var e = h()(["\n  overflow: hidden;\n  display: block;\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n  min-height: ", "px;\n"]);
        return E = function E() {
          return e;
        }, e;
      }

      function S() {
        var e = h()(["\n  display: flex;\n  position: relative;\n  transform: ", ";\n  transition: all ", "ms ", ";\n  will-change: translateX;\n"]);
        return S = function S() {
          return e;
        }, e;
      }

      var D = w.a.div(S(), function (e) {
        var t = e.selectedPage;
        return "translateX(-".concat(100 * t, "%)");
      }, j.a, j.d),
          T = w.a.div(E(), function (e) {
        return e.minHeight;
      }),
          C = function (e) {
        l()(r, e);
        var t,
            n = (t = r, function () {
          var e,
              n = m()(t);

          if (P()) {
            var r = m()(this).constructor;
            e = Reflect.construct(n, arguments, r);
          } else e = n.apply(this, arguments);

          return p()(this, e);
        });

        function r() {
          var e;
          return o()(this, r), e = n.call(this), y()(u()(e), "adaptHeight", function () {
            var t = e.props.selectedPage,
                n = e.container.current && e.container.current.querySelector('[data-index="'.concat(t, '"]'));
            e.offsetHeight !== n.offsetHeight && (e.container.current.style.height = "".concat(n.offsetHeight, "px"), e.offsetHeight = n.offsetHeight);
          }), e.container = O.a.createRef(), e.redrawLoop = void 0, e.offsetHeight = 0, e;
        }

        return a()(r, [{
          key: "componentDidMount",
          value: function value() {
            this.props.fixedHeight || this.adaptHeight();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            var t = this.props,
                n = t.selectedPage,
                r = t.shouldTriggerRedrawLoop,
                o = t.fixedHeight,
                i = e.selectedPage,
                a = e.shouldTriggerRedrawLoop,
                c = e.fixedHeight;
            o || c || n === i && r === a || (clearInterval(this.redrawLoop), r ? this.redrawLoop = setInterval(this.adaptHeight, j.f) : this.adaptHeight());
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            clearInterval(this.redrawLoop);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.selectedPage,
                n = e.children,
                r = e.minHeight;
            return O.a.createElement(T, {
              innerRef: this.container,
              minHeight: r
            }, O.a.createElement(D, {
              selectedPage: t
            }, n.map(function (e, t) {
              return O.a.createElement("div", {
                key: t,
                style: {
                  display: "inherit",
                  position: "relative",
                  maxWidth: "100%",
                  width: "100%",
                  flex: "1 0 auto",
                  alignItems: "flex-start",
                  height: "inherit"
                }
              }, e);
            })));
          }
        }]), r;
      }(v.Component);

      C.defaultProps = {
        shouldTriggerRedrawLoop: !1,
        fixedHeight: !1,
        minHeight: 200
      }, t.a = C;
    },
    98: function _(e, t) {
      e.exports = require("react-remove-scroll");
    }
  });
});